import { liveItems } from "@/components/events/DrinkMenu";
import { Label } from "@/components/ui/label";
import { Check } from "lucide-react";

const MAX = 5;

/** Up-to-five flavor selection that rides along with the booking request. */
export const FlavorPicker = ({ menu, selected = [], onChange }) => {
  const categories = menu?.categories || [];
  if (!categories.length) return null;
  const full = selected.length >= MAX;

  const toggle = (name) => {
    if (selected.includes(name)) {
      onChange(selected.filter((n) => n !== name));
      return;
    }
    if (full) return;
    onChange([...selected, name]);
  };

  return (
    <div data-testid="flavor-picker">
      <Label className="mono text-[11px] tracking-widest text-muted-foreground">
        PICK YOUR FLAVORS (UP TO {MAX})
      </Label>
      <div className="mono mt-1 text-[10px] tracking-widest text-primary">
        <span data-testid="flavor-count">{selected.length}</span> OF {MAX} SELECTED
        {full ? " — THAT'S YOUR LINEUP" : ""}
      </div>

      <div className="mt-4 space-y-5">
        {categories.map((c) => (
          <div key={c.id}>
            <div className="mono text-[10px] tracking-widest text-muted-foreground">
              {(c.tab || c.name).toUpperCase()}
            </div>
            <div className="mt-2 flex flex-wrap gap-2">
              {liveItems(c)
                .filter((i) => i.available !== false)
                .map((item) => {
                  const on = selected.includes(item.name);
                  return (
                    <button
                      key={item.id}
                      type="button"
                      data-testid={`flavor-pick-${item.id}`}
                      aria-pressed={on}
                      disabled={!on && full}
                      onClick={() => toggle(item.name)}
                      className={`mono flex items-center gap-1.5 rounded-sm border px-3 py-2 text-[10px] tracking-widest transition-colors ${
                        on
                          ? "border-primary bg-primary text-primary-foreground"
                          : "border-border text-muted-foreground hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-border disabled:hover:text-muted-foreground"
                      }`}
                    >
                      {on ? <Check size={11} /> : null}
                      {item.name.toUpperCase()}
                    </button>
                  );
                })}
            </div>
          </div>
        ))}
      </div>

      <p className="mono mt-4 text-[10px] leading-relaxed tracking-widest text-muted-foreground">
        WE PRINT A CUSTOM MENU WITH YOUR PICKS. FINAL SELECTIONS CAN STILL CHANGE UP TO 7 DAYS
        BEFORE THE EVENT.
      </p>
    </div>
  );
};
